<template>
  <div>
    <audio-step v-if="data.type === 'audio'" :data="data" v-on="$listeners"></audio-step>
  </div>
</template>

<script>
import AudioStep from "@/components/Interactive/Step/Audio";

export default {
  name: "Step",
  components: { AudioStep },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    console.log(this.data);
  },
};
</script>
